module.exports = __webpack_public_path__ + "static/media/rgn.dd491a16.svg";